module.exports = __webpack_public_path__ + "static/media/bg-home-header-mob.64873481.png";